import styles from './asset/userLayout.module.scss';
import AnnouncementModal from '../AnnouncementModal/AnnouncementModal';
import { AnnouncementProvider, useAnnouncements } from '../AnnouncementModal/context/AnnouncementContext';

const UserLayoutContent = ({ children }) => {
    const { showAnnouncements, closeAnnouncements } = useAnnouncements();

    return (
        <div className={styles.userLayout}>
            {children}
            <AnnouncementModal
                isVisible={showAnnouncements}
                onClose={closeAnnouncements}
            />
        </div>
    );
};

const UserLayout = ({ children }) => {
    return (
        <AnnouncementProvider>
            <UserLayoutContent>
                {children}
            </UserLayoutContent>
        </AnnouncementProvider>
    );
};

export default UserLayout;